'use strict'

module.exports = {
  DATE_FORMAT: 'yyyy-mm-dd HH:MM:ss.l o',
  MESSAGE_KEY: 'msg'
}



//////////////////
// WEBPACK FOOTER
// ./~/pino-pretty/lib/constants.js
// module id = 3326
// module chunks = 16